import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ProgressSteps } from '@morressier/alembic';

interface StepHeaderProps {
  currentStep: number;
  totalSteps: number;
  heading: string;
  description: string;
  marginY?: number;
}

// TODO: MarginY Props should not be here, the parent component should use the Gap prop instead.
// marginY props is a temporary solution to avoid breaking changes.
// jira ticket: https://morressier.atlassian.net/browse/COMA-1444
const StepHeader: React.FC<StepHeaderProps> = ({
  currentStep,
  totalSteps,
  heading,
  description,
  marginY = 4
}) => (
  <>
    <ProgressSteps currentStep={currentStep} totalSteps={totalSteps} />
    <Flex gap={1} marginY={marginY} flexDirection="column">
      {currentStep > 0 && totalSteps > 0 && (
        <Text textStyle="headingOverline">
          Step {currentStep} of {totalSteps}
        </Text>
      )}
      <Text textStyle="headingSection">{heading}</Text>
      <Text textStyle="textContext">{description}</Text>
    </Flex>
  </>
);

export default StepHeader;
